
  <app-create-comment [forumId]="discussForum.forum_id" [commentId]="discussForum.forum_id+'-main'" [parentCommentId]="0" [commentType]="discussForum.forum_type" [isParent]="isParent"(commentSaved)="refreshCommentSection($event)"></app-create-comment>

<div class="post-featured unanswered-posts mt-2 mb-4">
  <div class="post-unanswered-desc">
      <div class="bg-white box-shadow border-radius-10 border-all mb-4" *ngFor="let result of results">
        <comment-list [comment]="result"></comment-list>
      </div>
      <div *ngIf="showLoadMore">
        <button class="btn btn-dark" (click)="loadMoreComments()">Load More</button>
      </div>
  </div>
